import promotionApi from '../../api/promotion'

// initial state
const state = {
}

const getters = {
}

const actions = {
  //create ({ dispatch, commit }, params) {
    //return new Promise((resolve, reject) => {
      //promotionApi.create(params, promotion => {
        //commit('addToUser', promotion, params.user_id)
        //resolve()
      //},
      //error => {
        //console.log('Something broke at the API');
        //reject()
      //})
    //})
  //},
}

const mutations = {
  //addToUser (state, promotion, user_id) {
    //state.detailedEmployee.promotions.push(promotion)
  //},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
